import { render, staticRenderFns } from "./ConsentimientoInformadoCirugia.vue?vue&type=template&id=1a305d6f"
import script from "./ConsentimientoInformadoCirugia.vue?vue&type=script&lang=js"
export * from "./ConsentimientoInformadoCirugia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports